import React from "react"

import { ConnectorDialog } from "~/ui-rtk/components/features/connectors"

import { connectorIcons } from "~/ui-rtk/shared/constants/image-paths.contants"
import { Button } from "~/ui-rtk/components/ui/controls"
import MetaPermissionsNote from "../shared/MetaPermissionsNote"

type InstagramBusinessFormProps = {
  isOpen: boolean
  onClose: () => void
  onContinue: () => void
}

const InstagramBusinessForm: React.FC<InstagramBusinessFormProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => (
  <ConnectorDialog
    imgSrc={connectorIcons.instagram}
    alt="Instagram Business Logo"
    title="Connection to Instagram Business"
    isOpen={isOpen}
    onClose={onClose}
  >
    <MetaPermissionsNote />

    <Button
      variant={{ variant: "solid", color: "white" }}
      onClick={onContinue}
      className="w-full"
    >
      Continue
    </Button>
  </ConnectorDialog>
)

export default InstagramBusinessForm
